'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _ScrollBar = require('./ScrollBar.scss');

var _ScrollBar2 = _interopRequireDefault(_ScrollBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollBar = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ScrollBar, _Component);

    function ScrollBar() {
        (0, _classCallCheck3.default)(this, ScrollBar);
        return (0, _possibleConstructorReturn3.default)(this, (ScrollBar.__proto__ || (0, _getPrototypeOf2.default)(ScrollBar)).apply(this, arguments));
    }

    (0, _createClass3.default)(ScrollBar, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'maxHeight', 'showScrollBar', 'children']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                maxHeight = _props.maxHeight,
                showScrollBar = _props.showScrollBar;


            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ScrollBar2.default.seeMoreItems]).join(' ').trim();
            var trackClass = showScrollBar ? _ScrollBar2.default['scroll-track'] : _ScrollBar2.default['hide-scroll-track'];
            var thumbClass = showScrollBar ? _ScrollBar2.default['scroll-thumb'] : _ScrollBar2.default['hide-scroll-thumb'];
            return (0, _jsx3.default)(_reactCustomScrollbars.Scrollbars, {
                autoHeight: true,
                autoHeightMax: maxHeight,
                hideTracksWhenNotNeeded: true,
                renderView: function renderView(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: classes }));
                },
                renderTrackVertical: function renderTrackVertical(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: trackClass }));
                },
                renderThumbVertical: function renderThumbVertical(props) {
                    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: thumbClass }));
                },
                universal: true
            }, void 0, this.props.children);
        }
    }]);
    return ScrollBar;
}(_react.Component), _class.defaultProps = {
    className: '',
    maxHeight: 600,
    showScrollBar: true
}, _temp);
exports.default = ScrollBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollBar/ScrollBar.js
// module id = ZW0g
// module chunks = 46